import cepingTemplateSelector from './cepingTemplate-selector.vue';

export default {
  install(application) {
    application.component('yx-cepingTemplate-selector', cepingTemplateSelector);
  },
};
